import { render, staticRenderFns } from "./AddUpdateUniformRequestForm.vue?vue&type=template&id=1c2fed2d&scoped=true"
import script from "./AddUpdateUniformRequestForm.vue?vue&type=script&lang=js"
export * from "./AddUpdateUniformRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2fed2d",
  null
  
)

export default component.exports